import { FunctionComponent } from 'react';
import { FilterModalTextInput } from '../../../../sharedComponents/filter/FilterModal';
import { CompoundFilterProps } from './CompoundFilterProps';
import { useOnChangeTextFilter } from '../../../../sharedComponents/filter/useOnChangeTextFilter';

export const FinalDestinationFilter: FunctionComponent<CompoundFilterProps> = ({ localFilters, setLocalFilters }) => {
    const handleChange = useOnChangeTextFilter('finalDestinationFilter', setLocalFilters);
    return (
        <FilterModalTextInput
            id="final-destination-filter"
            headerMessageId="outboundOrderBook.common.filter.finalDestination"
            inputAddon="rioglyph rioglyph-finish"
            placeholderMessageId="outboundOrderBook.common.filter.enterFinalDestination"
            isOptional
            value={localFilters.finalDestinationFilter}
            onChange={handleChange}
        />
    );
};
